var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
// SPDX-FileCopyrightText: 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import { Link as RouterLink, useNavigate, useParams, redirect, useLocation, useSubmit, } from "react-router-dom";
import { selectBallotStyleByElectionId } from "../store/ballotStyles/ballotStylesSlice";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { Box, CircularProgress } from "@mui/material";
import { PageLimit, Icon, IconButton, theme, BallotHash, Dialog, WarnBox, } from "@sequentech/ui-essentials";
import { stringToHtml, EVotingPortalAuditButtonCfg, EGraphQLInternalErrorMessage, EGraphQLErrorCode, ECastVoteGoldLevelPolicy, EElectionEventContestEncryptionPolicy, } from "@sequentech/ui-core";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { faCircleQuestion, faAngleLeft, faAngleRight, faFire, } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { selectAuditableBallot } from "../store/auditableBallots/auditableBallotsSlice";
import { Question } from "../components/Question/Question";
import { useMutation, useQuery, ApolloError } from "@apollo/client";
import { INSERT_CAST_VOTE } from "../queries/InsertCastVote";
import { GET_ELECTIONS } from "../queries/GetElections";
import { provideBallotService } from "../services/BallotService";
import { addCastVotes } from "../store/castVotes/castVotesSlice";
import { useRootBackLink } from "../hooks/root-back-link";
import { CastBallotsErrorType, VotingPortalErrorType, } from "../services/VotingPortalError";
import Stepper from "../components/Stepper";
import { selectBallotSelectionByElectionId } from "../store/ballotSelections/ballotSelectionsSlice";
import { sortContestList, hashBallot, hashMultiBallot, } from "@sequentech/ui-core";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { AuthContext } from "../providers/AuthContextProvider";
import { clearSessionStorageBallotData, BALLOT_DATA_KEY, BALLOT_DATA_EXPIRATION_KEY, } from "../store/castVotes/sessionBallotData";
import { setConfirmationScreenData } from "../store/castVotes/confirmationScreenDataSlice";
import { selectElectionById } from "../store/elections/electionsSlice";
var StyledLink = styled(RouterLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: auto 0;\n    text-decoration: none;\n"], ["\n    margin: auto 0;\n    text-decoration: none;\n"])));
var StyledTitle = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n"])));
var ActionsContainer = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    gap: 2px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    gap: 2px;\n"])));
var StyledButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"], ["\n    display: flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"])));
var StyledIcon = styled(Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    min-width: 14px;\n    padding: 5px;\n"], ["\n    min-width: 14px;\n    padding: 5px;\n"])));
var StyledCircularProgress = styled(CircularProgress)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 14px !important;\n    height: 14px !important;\n"], ["\n    width: 14px !important;\n    height: 14px !important;\n"])));
var AuditButton = function (_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (_jsxs(StyledButton, __assign({ className: "audit-button", sx: { width: { xs: "100%", sm: "200px" } }, variant: "warning", onClick: onClick }, { children: [_jsx(Icon, { icon: faFire, size: "sm" }), _jsx(Box, { children: t("reviewScreen.auditButton") })] })));
};
var AuditBallotHelpDialog = function (_a) {
    var auditBallotHelp = _a.auditBallotHelp, handleClose = _a.handleClose;
    var t = useTranslation().t;
    return (_jsx(Dialog, __assign({ handleClose: handleClose, open: auditBallotHelp, title: t("reviewScreen.auditBallotHelpDialog.title"), ok: t("reviewScreen.auditBallotHelpDialog.ok"), cancel: t("reviewScreen.auditBallotHelpDialog.cancel"), variant: "warning", maxWidth: "md" }, { children: stringToHtml(t("reviewScreen.auditBallotHelpDialog.content")) })));
};
var LoadingOrCastButton = function (_a) {
    var onClick = _a.onClick, isCastingBallot = _a.isCastingBallot, className = _a.className;
    var t = useTranslation().t;
    return (_jsxs(StyledButton, __assign({ className: className, sx: { margin: "auto 0", width: { xs: "100%", sm: "200px" } }, disabled: isCastingBallot, onClick: onClick }, { children: [_jsx(Box, { children: t("reviewScreen.castBallotButton") }), isCastingBallot ? (_jsx(StyledCircularProgress, { color: "inherit" })) : (_jsx(StyledIcon, { icon: faAngleRight, size: "sm" }))] })));
};
var useAddFakeCastVote = function (tenantId, eventId) {
    var dispatch = useAppDispatch();
    return function () {
        var newCastVote = {
            id: eventId !== null && eventId !== void 0 ? eventId : "",
            tenant_id: tenantId !== null && tenantId !== void 0 ? tenantId : "",
            election_id: eventId,
            area_id: eventId,
            created_at: null,
            last_updated_at: null,
            annotations: null,
            labels: null,
            content: "",
            cast_ballot_signature: "",
            voter_id_string: null,
            election_event_id: eventId !== null && eventId !== void 0 ? eventId : "",
        };
        console.log("faking casting demo vote");
        dispatch(addCastVotes([newCastVote]));
    };
};
var useTryInsertCastVote = function () {
    var t = useTranslation().t;
    var insertCastVote = useMutation(INSERT_CAST_VOTE)[0];
    var dispatch = useAppDispatch();
    return function (electionId, ballotId, content, setErrorMsg) { return __awaiter(void 0, void 0, void 0, function () {
        var result, newCastVote, error_1, castError, errorExtensions, errorCode, internalErrMessage;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _k.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, insertCastVote({
                            variables: {
                                electionId: electionId,
                                ballotId: ballotId,
                                content: content,
                            },
                        })];
                case 1:
                    result = _k.sent();
                    if (result.errors) {
                        console.log(result.errors.map(function (e) { return e.message; }));
                        setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.UNABLE_TO_FETCH_DATA)));
                        return [2 /*return*/, false];
                    }
                    newCastVote = (_a = result.data) === null || _a === void 0 ? void 0 : _a.insert_cast_vote;
                    if (newCastVote) {
                        dispatch(addCastVotes([newCastVote]));
                    }
                    return [2 /*return*/, true];
                case 2:
                    error_1 = _k.sent();
                    console.log(error_1);
                    castError = error_1;
                    errorExtensions = (_c = (_b = castError === null || castError === void 0 ? void 0 : castError.graphQLErrors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.extensions;
                    if ((_d = castError === null || castError === void 0 ? void 0 : castError.message) === null || _d === void 0 ? void 0 : _d.includes("internal error")) {
                        setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.INTERNAL_ERROR))); // can happen if the backend panics
                    }
                    else if (errorExtensions === null || errorExtensions === void 0 ? void 0 : errorExtensions.code) {
                        errorCode = errorExtensions === null || errorExtensions === void 0 ? void 0 : errorExtensions.code;
                        console.log(castError.name, castError.message);
                        internalErrMessage = (_j = (_h = (_g = (_f = (_e = castError === null || castError === void 0 ? void 0 : castError.graphQLErrors) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.extensions) === null || _g === void 0 ? void 0 : _g.internal) === null || _h === void 0 ? void 0 : _h.error) === null || _j === void 0 ? void 0 : _j.message;
                        console.log(errorCode, internalErrMessage);
                        if (errorCode === EGraphQLErrorCode.UNEXPECTED &&
                            internalErrMessage === EGraphQLInternalErrorMessage.TIMEOUT_ERROR) {
                            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.CAST_VOTE_TIMEOUT)));
                        }
                        else {
                            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.CAST_VOTE, "_").concat(errorCode)));
                        }
                    }
                    else if (error_1 instanceof ApolloError && error_1.networkError) {
                        console.log(error_1.name, error_1.message, error_1.cause, error_1.networkError);
                        setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.NETWORK_ERROR)));
                    }
                    else {
                        setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.CAST_VOTE))); // Generic error
                    }
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
var ActionButtons = function (_a) {
    var _b, _c;
    var ballotStyle = _a.ballotStyle, auditableBallot = _a.auditableBallot, auditButtonCfg = _a.auditButtonCfg, castVoteConfirmModal = _a.castVoteConfirmModal, ballotId = _a.ballotId, setErrorMsg = _a.setErrorMsg, isGoldenPolicy = _a.isGoldenPolicy, isMultiContest = _a.isMultiContest;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var location = useLocation();
    var _d = useState(false), auditBallotHelp = _d[0], setAuditBallotHelp = _d[1];
    var isCastingBallot = useRef(false);
    var _e = React.useState(false), isConfirmCastVoteModal = _e[0], setConfirmCastVoteModal = _e[1];
    var _f = useParams(), tenantId = _f.tenantId, eventId = _f.eventId;
    var _g = provideBallotService(), toHashableBallot = _g.toHashableBallot, toHashableMultiBallot = _g.toHashableMultiBallot;
    var submit = useSubmit();
    var isDemo = !!((_c = (_b = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _b === void 0 ? void 0 : _b.public_key) === null || _c === void 0 ? void 0 : _c.is_demo);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var authContext = useContext(AuthContext);
    var isGoldUser = authContext.isGoldUser, reauthWithGold = authContext.reauthWithGold;
    var addFakeCastVote = useAddFakeCastVote(tenantId, eventId);
    var tryInsertCastVote = useTryInsertCastVote();
    var handleClose = function (value) {
        setAuditBallotHelp(false);
        if (value) {
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(ballotStyle.election_id, "/audit").concat(location.search));
        }
    };
    var handleCloseCastVoteDialog = function (value) {
        setConfirmCastVoteModal(false);
        if (value) {
            castBallotAction();
        }
    };
    var storeBallotDataAndReauth = function (ballotData) { return __awaiter(void 0, void 0, void 0, function () {
        var errorType, FIVE_MINUTES, baseUrl, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    errorType = VotingPortalErrorType.UNABLE_TO_CAST_BALLOT;
                    try {
                        FIVE_MINUTES = 5 * 60 * 1000;
                        // Store the data with expiration info
                        sessionStorage.setItem(BALLOT_DATA_KEY, JSON.stringify(ballotData));
                        sessionStorage.setItem(BALLOT_DATA_EXPIRATION_KEY, (Date.now() + FIVE_MINUTES).toString());
                    }
                    catch (e) {
                        console.error("Error saving ballotData to sessionStorage", e);
                        clearSessionStorageBallotData();
                        setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.SESSION_STORAGE_ERROR)));
                        return [2 /*return*/, submit({ error: errorType }, { method: "post" })];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    baseUrl = new URL(window.location.href);
                    return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                case 2:
                    _a.sent();
                    return [2 /*return*/, submit(null, { method: "post" })];
                case 3:
                    error_2 = _a.sent();
                    console.error("Re-authentication failed:", error_2);
                    clearSessionStorageBallotData();
                    setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.REAUTH_FAILED)));
                    return [2 /*return*/, submit({ error: errorType }, { method: "post" })];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var castBallotAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var errorType, ballotData, hashableBallot, ballotError, ballotData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    errorType = VotingPortalErrorType.UNABLE_TO_CAST_BALLOT;
                    isCastingBallot.current = true;
                    if (!(isDemo || globalSettings.DISABLE_AUTH)) return [3 /*break*/, 3];
                    if (!isGoldenPolicy) return [3 /*break*/, 2];
                    ballotData = {
                        ballotId: ballotId,
                        electionId: ballotStyle.election_id,
                        isDemo: true,
                        ballot: JSON.stringify("{}"),
                        timestamp: Date.now(), // Add timestamp for expiration check
                    };
                    return [4 /*yield*/, storeBallotDataAndReauth(ballotData)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    addFakeCastVote();
                    return [2 /*return*/, submit(null, { method: "post" })];
                case 3:
                    try {
                        hashableBallot = isMultiContest
                            ? toHashableMultiBallot(auditableBallot)
                            : toHashableBallot(auditableBallot);
                    }
                    catch (error) {
                        isCastingBallot.current = false;
                        console.error(error);
                        ballotError = error || undefined;
                        if (ballotError === null || ballotError === void 0 ? void 0 : ballotError.error_type) {
                            setErrorMsg(t("reviewScreen.error.".concat(ballotError.error_type)));
                        }
                        else {
                            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.TO_HASHABLE_BALLOT_ERROR)));
                        }
                        return [2 /*return*/, submit({ error: errorType }, { method: "post" })];
                    }
                    if (!isGoldenPolicy) return [3 /*break*/, 5];
                    ballotData = {
                        ballotId: ballotId,
                        electionId: ballotStyle.election_id,
                        isDemo: isDemo,
                        ballot: JSON.stringify(hashableBallot),
                        timestamp: Date.now(), // Add timestamp for expiration check
                    };
                    return [4 /*yield*/, storeBallotDataAndReauth(ballotData)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5: return [4 /*yield*/, tryInsertCastVote(ballotStyle.election_id, ballotId, JSON.stringify(hashableBallot), setErrorMsg)];
                case 6:
                    if (!(_a.sent())) {
                        isCastingBallot.current = false;
                        return [2 /*return*/, submit({ error: errorType }, { method: "post" })];
                    }
                    return [2 /*return*/, submit(null, { method: "post" })];
            }
        });
    }); };
    return (_jsxs(Box, __assign({ sx: { marginBottom: "10px", marginTop: "10px" } }, { children: [auditButtonCfg === EVotingPortalAuditButtonCfg.SHOW ? (_jsx(AuditBallotHelpDialog, { auditBallotHelp: auditBallotHelp, handleClose: handleClose })) : null, _jsxs(ActionsContainer, __assign({ className: "actions-container" }, { children: [_jsx(StyledLink, __assign({ to: "/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(ballotStyle.election_id, "/vote").concat(location.search), sx: { margin: "auto 0", width: { xs: "100%", sm: "200px" } } }, { children: _jsxs(StyledButton, __assign({ sx: { width: { xs: "100%", sm: "200px" } } }, { children: [_jsx(Icon, { icon: faAngleLeft, size: "sm" }), _jsx(Box, { children: t("reviewScreen.backButton") })] })) })), auditButtonCfg === EVotingPortalAuditButtonCfg.SHOW ? (_jsx(AuditButton, { onClick: function () { return setAuditBallotHelp(true); } })) : null, _jsx(LoadingOrCastButton, { className: "cast-ballot-button", isCastingBallot: isCastingBallot.current, onClick: function () {
                            return castVoteConfirmModal ? setConfirmCastVoteModal(true) : castBallotAction();
                        } })] })), _jsx(Dialog, __assign({ handleClose: handleCloseCastVoteDialog, open: isConfirmCastVoteModal, title: t("reviewScreen.confirmCastVoteDialog.title"), ok: t("reviewScreen.confirmCastVoteDialog.ok"), cancel: t("reviewScreen.confirmCastVoteDialog.cancel"), variant: "info" }, { children: stringToHtml(t("reviewScreen.confirmCastVoteDialog.content")) }))] })));
};
export var ReviewScreen = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var electionId = useParams().electionId;
    var ballotStyle = useAppSelector(selectBallotStyleByElectionId(String(electionId)));
    var location = useLocation();
    var auditableBallot = useAppSelector(selectAuditableBallot(String(electionId)));
    var _k = useState(false), auditBallotHelp = _k[0], setAuditBallotHelp = _k[1];
    var _l = useState(false), openBallotIdHelp = _l[0], setOpenBallotIdHelp = _l[1];
    var _m = useState(false), openReviewScreenHelp = _m[0], setReviewScreenHelp = _m[1];
    var _o = provideBallotService(), interpretContestSelection = _o.interpretContestSelection, interpretMultiContestSelection = _o.interpretMultiContestSelection;
    var t = useTranslation().t;
    var backLink = useRootBackLink();
    var navigate = useNavigate();
    var submit = useSubmit();
    var _p = useParams(), tenantId = _p.tenantId, eventId = _p.eventId;
    var _q = useState(), errorMsg = _q[0], setErrorMsg = _q[1];
    var authContext = useContext(AuthContext);
    var isGoldUser = authContext.isGoldUser, reauthWithGold = authContext.reauthWithGold;
    var isCastingBallot = useRef(false);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var dispatch = useAppDispatch();
    var addFakeCastVote = useAddFakeCastVote(tenantId, eventId);
    var tryInsertCastVote = useTryInsertCastVote();
    var electionFromRedux = useAppSelector(selectElectionById(String(electionId)));
    var dataElections = useQuery(GET_ELECTIONS, {
        variables: {
            electionIds: electionId ? [electionId] : [],
        },
        skip: globalSettings.DISABLE_AUTH || electionFromRedux !== undefined,
        onError: function (error) {
            if (error.networkError) {
                setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.NETWORK_ERROR)));
            }
            else {
                setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.UNABLE_TO_FETCH_DATA)));
            }
        },
    }).data;
    var isGoldenPolicy = useMemo(function () {
        var _a, _b;
        return electionFromRedux !== undefined
            ? ((_a = electionFromRedux === null || electionFromRedux === void 0 ? void 0 : electionFromRedux.presentation) === null || _a === void 0 ? void 0 : _a.cast_vote_gold_level) ===
                ECastVoteGoldLevelPolicy.GOLD_LEVEL
            : (_b = dataElections === null || dataElections === void 0 ? void 0 : dataElections.sequent_backend_election) === null || _b === void 0 ? void 0 : _b.some(function (item) {
                var _a;
                return item.id === electionId &&
                    ((_a = item.presentation) === null || _a === void 0 ? void 0 : _a.cast_vote_gold_level) ===
                        ECastVoteGoldLevelPolicy.GOLD_LEVEL;
            });
    }, [electionFromRedux, dataElections]);
    console.log(electionFromRedux !== undefined);
    var auditButtonCfg = (_c = (_b = (_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _a === void 0 ? void 0 : _a.election_presentation) === null || _b === void 0 ? void 0 : _b.audit_button_cfg) !== null && _c !== void 0 ? _c : EVotingPortalAuditButtonCfg.SHOW;
    var castVoteConfirmModal = (_f = (_e = (_d = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _d === void 0 ? void 0 : _d.election_presentation) === null || _e === void 0 ? void 0 : _e.cast_vote_confirm) !== null && _f !== void 0 ? _f : false;
    var isMultiContest = ((_g = auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.config.election_event_presentation) === null || _g === void 0 ? void 0 : _g.contest_encryption_policy) ==
        EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
    var hashableBallot = auditableBallot
        ? isMultiContest
            ? hashMultiBallot(auditableBallot)
            : hashBallot(auditableBallot)
        : undefined;
    var ballotId = useMemo(function () {
        return auditableBallot && hashableBallot ? hashableBallot : undefined;
    }, [auditableBallot, hashableBallot]);
    var selectionState = useAppSelector(selectBallotSelectionByElectionId((_h = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.election_id) !== null && _h !== void 0 ? _h : ""));
    var errorSelectionState = useMemo(function () {
        if (!selectionState || !ballotStyle) {
            return [];
        }
        return isMultiContest
            ? interpretMultiContestSelection(selectionState, ballotStyle.ballot_eml)
            : interpretContestSelection(selectionState, ballotStyle.ballot_eml);
    }, [selectionState, isMultiContest, ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml]);
    if (ballotId && (auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash) && ballotId !== (auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash)) {
        setErrorMsg(t("errors.encoding.writeInCharsExceeded", {
            ballotId: ballotId,
            auditableBallotHash: auditableBallot.ballot_hash,
        }));
    }
    var handleCloseDialogAuditHelp = function (value) {
        setAuditBallotHelp(false);
        if (value) {
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.election_id, "/audit").concat(location.search));
        }
    };
    function handleCloseDialogIdHelp(val) {
        setOpenBallotIdHelp(false);
        if (val) {
            if (ballotStyle && tenantId && eventId) {
                navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(ballotStyle.election_id, "/audit"));
            }
            else {
                navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser"));
            }
        }
    }
    var getBallotDataFromSessionStorage = function () {
        var ballotData;
        var expirationTime;
        var storedExpirationTime = sessionStorage.getItem(BALLOT_DATA_EXPIRATION_KEY);
        var storedData = sessionStorage.getItem(BALLOT_DATA_KEY);
        if (!storedExpirationTime || !storedData) {
            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.SESSION_STORAGE_ERROR)));
            return undefined;
        }
        expirationTime = parseInt(storedExpirationTime, 10);
        if (expirationTime && Date.now() > expirationTime) {
            // Data has expired, clean up and return error
            console.error("Re-authentication failed: EXPIRED");
            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.SESSION_EXPIRED)));
            return undefined;
        }
        try {
            ballotData = JSON.parse(storedData);
        }
        catch (error) {
            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.PARSE_BALLOT_DATA_ERROR)));
            return undefined;
        }
        if (!ballotData || !ballotData.ballotId || !ballotData.electionId || !ballotData.ballot) {
            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.NOT_VALID_BALLOT_DATA_ERROR)));
            return undefined;
        }
        return ballotData;
    };
    // Cast the ballot automatically after reauth with golden user
    var goldenUserCastBallotAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var errorType, ballotData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isCastingBallot.current = true;
                    errorType = VotingPortalErrorType.UNABLE_TO_CAST_BALLOT;
                    ballotData = getBallotDataFromSessionStorage();
                    if (!ballotData) {
                        isCastingBallot.current = false;
                        clearSessionStorageBallotData();
                        return [2 /*return*/, submit({ error: errorType }, { method: "post" })];
                    }
                    if (ballotData === null || ballotData === void 0 ? void 0 : ballotData.isDemo) {
                        addFakeCastVote();
                        clearSessionStorageBallotData();
                        isCastingBallot.current = false;
                        return [2 /*return*/, submit(null, { method: "post" })];
                    }
                    return [4 /*yield*/, tryInsertCastVote(ballotData.electionId, ballotData.ballotId, ballotData.ballot, setErrorMsg)];
                case 1:
                    if (!(_a.sent())) {
                        isCastingBallot.current = false;
                        return [2 /*return*/, submit({ error: errorType }, { method: "post" })];
                    }
                    // set ConfirmationScreenData (ballotId and isDemo) to a new object in redux state, so it can be read later on from the confirmation screen
                    dispatch(setConfirmationScreenData({
                        electionId: ballotData.electionId,
                        confirmationScreenData: {
                            ballotId: ballotData.ballotId,
                            isDemo: ballotData.isDemo,
                        },
                    }));
                    clearSessionStorageBallotData();
                    return [2 /*return*/, submit(null, { method: "post" })];
            }
        });
    }); };
    // Selectively clear ballot-related session data when component mounts
    useEffect(function () {
        // Only clear session data if we're not in the middle of a golden policy flow
        if (!isGoldUser() && !ballotStyle && !auditableBallot && !selectionState) {
            clearSessionStorageBallotData();
        }
    }, []);
    useEffect(function () {
        if ((!ballotStyle || !auditableBallot || !selectionState) && isGoldenPolicy) {
            if (isGoldUser()) {
                if (!isCastingBallot.current) {
                    goldenUserCastBallotAction();
                    clearSessionStorageBallotData();
                }
            }
            else {
                // If not a gold user but golden policy is required, redirect to election chooser
                navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser"));
            }
        }
        else {
            console.log("Normal flow");
        }
    }, [ballotStyle, selectionState, auditableBallot, isGoldenPolicy]);
    if (!ballotStyle || !auditableBallot) {
        return errorMsg ? (_jsxs(Box, __assign({ sx: { margin: "auto 0" } }, { children: [_jsx(WarnBox, __assign({ variant: "error" }, { children: errorMsg })), _jsx(Box, __assign({ sx: {
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: "16px",
                    } }, { children: _jsx(StyledLink, __assign({ to: backLink, sx: { width: { xs: "100%", sm: "200px" } } }, { children: _jsxs(StyledButton, __assign({ sx: { width: { xs: "100%", sm: "200px" } } }, { children: [_jsx(Icon, { icon: faAngleLeft, size: "sm" }), _jsx(Box, { children: t("reviewScreen.backButton") })] })) })) }))] }))) : (_jsx(CircularProgress, {}));
    }
    var contestsOrderType = (_j = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_presentation) === null || _j === void 0 ? void 0 : _j.contests_order;
    var contests = sortContestList(ballotStyle.ballot_eml.contests, contestsOrderType);
    return (_jsxs(PageLimit, __assign({ maxWidth: "lg", className: "review-screen screen" }, { children: [auditButtonCfg === EVotingPortalAuditButtonCfg.NOT_SHOW ? null : (_jsx(BallotHash, { hash: ballotId || "", onHelpClick: function () { return setOpenBallotIdHelp(true); } })), _jsx(Dialog, __assign({ handleClose: handleCloseDialogIdHelp, open: openBallotIdHelp, title: t("reviewScreen.ballotIdHelpDialog.title"), ok: t("reviewScreen.ballotIdHelpDialog.ok"), maxWidth: "md", middleActions: auditButtonCfg === EVotingPortalAuditButtonCfg.SHOW_IN_HELP
                    ? [
                        _jsx(AuditButton, { onClick: function () { return setAuditBallotHelp(true); } }, "audit-button"),
                    ]
                    : [], cancel: t("reviewScreen.ballotIdHelpDialog.cancel"), variant: "info" }, { children: stringToHtml(t("reviewScreen.ballotIdHelpDialog.content")) })), auditButtonCfg === EVotingPortalAuditButtonCfg.SHOW_IN_HELP ? (_jsx(AuditBallotHelpDialog, { auditBallotHelp: auditBallotHelp, handleClose: handleCloseDialogAuditHelp })) : null, _jsx(Box, __assign({ marginTop: "48px" }, { children: _jsx(Stepper, { selected: 2 }) })), _jsxs(StyledTitle, __assign({ variant: "h4", fontSize: "24px", fontWeight: "bold", sx: { margin: 0 } }, { children: [_jsx(Box, { children: t("reviewScreen.title") }), _jsx(IconButton, { icon: faCircleQuestion, sx: { fontSize: "unset", lineHeight: "unset", paddingBottom: "2px" }, fontSize: "16px", onClick: function () { return setReviewScreenHelp(true); } }), _jsx(Dialog, __assign({ handleClose: function () { return setReviewScreenHelp(false); }, open: openReviewScreenHelp, title: t("reviewScreen.reviewScreenHelpDialog.title"), ok: t("reviewScreen.reviewScreenHelpDialog.ok"), variant: "info" }, { children: stringToHtml(t("reviewScreen.reviewScreenHelpDialog.content")) }))] })), errorMsg && _jsx(WarnBox, __assign({ variant: "error" }, { children: errorMsg })), _jsx(Typography, __assign({ variant: "body2", sx: { color: theme.palette.customGrey.main } }, { children: stringToHtml(auditButtonCfg === EVotingPortalAuditButtonCfg.NOT_SHOW ||
                    auditButtonCfg === EVotingPortalAuditButtonCfg.SHOW_IN_HELP
                    ? t("reviewScreen.descriptionNoAudit")
                    : t("reviewScreen.description")) })), contests.map(function (question, index) { return (_jsx(Box, __assign({ className: "contest-".concat(index) }, { children: _jsx(Question, { ballotStyle: ballotStyle, question: question, isReview: true, setDecodedContests: function () { return undefined; }, errorSelectionState: errorSelectionState }) }), question.id)); }), !isCastingBallot.current && (_jsx(ActionButtons, { ballotStyle: ballotStyle, auditableBallot: auditableBallot, auditButtonCfg: auditButtonCfg, castVoteConfirmModal: castVoteConfirmModal, ballotId: ballotId !== null && ballotId !== void 0 ? ballotId : "", setErrorMsg: setErrorMsg, isGoldenPolicy: isGoldenPolicy !== null && isGoldenPolicy !== void 0 ? isGoldenPolicy : false, isMultiContest: isMultiContest }))] })));
};
export default ReviewScreen;
export function action(_a) {
    var request = _a.request;
    return __awaiter(this, void 0, void 0, function () {
        var data, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, request.formData()];
                case 1:
                    data = _b.sent();
                    error = data.get("error");
                    if (!error) {
                        return [2 /*return*/, redirect("../confirmation")];
                    }
                    return [2 /*return*/, null];
            }
        });
    });
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
